import {Injectable} from "@angular/core";
import {LocalStorageService} from "./local-storage.service";
import {IUser} from "../models/subscription.model";
import {
  IExerciseTitle
} from "../../features/dashboard/most-active-exercise-categories/app-exercises-category-select-dialog/app-exercises-category-select-dialog.component";
import {AccountService} from "./account.service";
import {BehaviorSubject, Observable} from "rxjs";
import {AuthService} from "./auth.service";
import {map} from "rxjs/internal/operators";

export interface ICachedUserInformation {
  [k: string]: ICachedLocation;
}

export interface ICachedLocation {
  leaderboardExercise: {
    configId: string;
    title: IExerciseTitle;
  }
}

@Injectable({
  providedIn: 'root'
})
export class UsersCacheStorageService{
  currentUser: IUser;
  private _cachedUser = new BehaviorSubject<ICachedUserInformation>(null);

  constructor(
      private localStorageService: LocalStorageService,
      private accountService: AccountService
  ) {
    this.accountService.userObservable.subscribe(account => {
      this.currentUser = account;
      this._cachedUser.next(this.cachedUsers[this.currentUser?.id])
    })
  }

  setLeaderboardExerciseConfig(configId: string, title: IExerciseTitle): void {
    const locationId = AuthService.getSelectedLocationId();
    this.currentCachedUser = {
      ...this.currentCachedUser,
      [locationId]: {
        leaderboardExercise: {
          configId,
          title
        }
      }
    } as ICachedUserInformation;

  }


  set currentCachedUser(cachedUser: ICachedUserInformation) {
    if(!this.currentUser?.id) return;
    const cachedUsers = {...this.cachedUsers, [this.currentUser?.id]: cachedUser}
    //this._cachedUser.next(cachedUser);
    this.localStorageService.setItem("users_cache", cachedUsers);
  }

  get currentCachedUser(): ICachedUserInformation {
    return this._cachedUser.value;
  }

  get currentCachedUserObservable(): Observable<ICachedUserInformation> {
    return this._cachedUser.asObservable();
  }

  get currentCachedLocationObservable(): Observable<ICachedLocation> {
    return this._cachedUser.asObservable().pipe(map(cachedUser => {
      const locationId = AuthService.getSelectedLocationId();
      if(cachedUser && cachedUser[locationId])
      return cachedUser[locationId];
      else return null; 
    }));
  }

  get cachedUsers(): Record<string, ICachedUserInformation> {
    return this.localStorageService.getItem("users_cache") as Record<string, ICachedUserInformation> ?? {};
  }
}
